import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=ad378c00"
import script from "./activityDetail.vue?vue&type=script&lang=js"
export * from "./activityDetail.vue?vue&type=script&lang=js"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=ad378c00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports